import React from 'react';
import PropTypes from 'prop-types';
import './svg.css';


const ReturnIcon = props => {
  const { fill, className } = props;
  return (
    <svg
      viewBox="5 4 20 20"
      height="18px"
      width="18px"
      // className='svg'
    >
      <path d="M11,8 C11.5522847,8 12,8.44771525 12,9 L12.0009007,19.1710242 C12.852919,19.4724771 13.5281625,20.1479338 13.8293257,21.0000889 L21,21 C21.5522847,21 22,21.4477153 22,22 C22,22.5522847 21.5522847,23 21,23 L13.8289758,23.0009007 C13.4168852,24.1656226 12.3058822,25 11,25 C9.34314575,25 8,23.6568542 8,22 C8,20.6937479 8.8348501,19.5824856 10.0000889,19.1706743 L10,10 L8,10 C7.44771525,10 7,9.55228475 7,9 C7,8.44771525 7.44771525,8 8,8 L11,8 Z M20.5,11 C21.3284271,11 22,11.6715729 22,12.5 L22,17.5 C22,18.3284271 21.3284271,19 20.5,19 L15.5,19 C14.6715729,19 14,18.3284271 14,17.5 L14,12.5 C14,11.6715729 14.6715729,11 15.5,11 L20.5,11 Z"  id="Combined-Shape" fill={fill ? fill : "#000"} fillRule="nonzero"></path>
    </svg>
  );
};

// ReturnIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default ReturnIcon;
